module.exports = __webpack_public_path__ + "media/images/bg-mv-bride-d5b5af491429970ca99f8052bc33c9b9.webp";